import React from 'react';
import { AdfNodeProps } from './AdfModelTypes';
import { AdfNode } from './AdfNode';

export const AdfParagraph = React.memo(({ node }: AdfNodeProps) => {
    return <p>{node.content?.map((x, i) => <AdfNode key={i} node={x} />)}</p>;
});
